import React from "react";
import Box from "@mui/material/Box";
import ChangeUserInfoForm from "../organisms/ChangeUserInfoForm";

export default function UserChangeInfoTemplate() {
  return (
    <Box sx={{ bgcolor: "#F2F3F4" }}>
      <Box
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        <ChangeUserInfoForm />
      </Box>
    </Box>
  );
}